import React, { useState } from 'react';
import './index.scss';
export default function Keyword({
  data,
  stabled,
  isSelected,
  getDetails,
  isClick,
}: any) {
  const [selected, setSelected] = useState(isSelected ? true : false);
  //  data 数据
  //  stabled 不需要hover交互时 样式类名stabled
  //  isSelected 是否选中样式
  //  isClick 是否点击数据
  //  getDetails 点击事件

  return (
    // type 1 绿色positive 2 红色negative 3 灰色neutral
    // 不需要hover交互时 样式类名stabled
    // 选中时 样式类名is-selected
    <span
      onClick={() => {
        // 暂时屏蔽交互
        // if (!stabled) setSelected(!selected);
        // if (isClick) getDetails();
      }}
      className={`dbo-keyword${
        data.type == 1
          ? ' dbo-keyword--green'
          : data.type == 2
          ? ' dbo-keyword--red'
          : ''
      }${stabled ? ' stabled' : ''}${selected ? ' is-selected' : ''}`}
    >
      {/* 如果有数字 样式类名strong-text */}
      {data.text}
      {data.num ? <span className="strong-text">{data.num}</span> : ''}
    </span>
  );
}
